import React from 'react';
import IntroWithButton from '../global/IntroWithButton';
import TimelineText from '../timeline/TimelineText';
import TimelineVideo from '../timeline/TimelineVideo';
import style from './ContentGrid.module.scss';
import SliderWithText from './SliderWithText';
import Observer from 'react-intersection-observer';

const ContentGrid = ({
  eraInView,
  title,
  grid_contents,
  isBasicPage = false,
}) => {
  return (
    <div
      className={
        isBasicPage ? style.basicGridWrapper : style.contentGridWrapper
      }
    >
      {title !== '<strong></strong>' && (
        <Observer className={style.chapterInfoWrapper} triggerOnce={true}>
          {inview => (
            <IntroWithButton
              index={0}
              title={title}
              doSplitText={true}
              startHidden={true}
              show={inview}
            />
          )}
        </Observer>
      )}
      {grid_contents && (
        <div className={style.contentGrid}>
          {grid_contents.map((content, index) => {
            switch (content.grid_item_type) {
              case 'slideshow':
                return (
                  <SliderWithText
                    eraInView={eraInView}
                    key={`${content.title}-${index}-slider-text`}
                    {...content}
                  />
                );
              case 'text':
                return (
                  <TimelineText
                    key={`${content.body}-${index}-text`}
                    {...content}
                  />
                );
              case 'video':
                return (
                  <TimelineVideo
                    key={`${content.video_source}-${index}-video`}
                    {...content}
                  />
                );
              default:
                return (
                  <SliderWithText
                    key={`${content.title}-${index}-slider`}
                    {...content}
                  />
                );
            }
          })}
        </div>
      )}
    </div>
  );
};

export default ContentGrid;



// WEBPACK FOOTER //
// ./src/components/global/ContentGrid.js